module.exports = __webpack_public_path__ + "static/steelhat-cbdeb960f789b9951c91d6da35a6efde.jpeg";